import {AnalysisViewGraphQL} from 'analysis-tool/AnalysisTypes';
import {ConfigDataFrameInfo} from 'pipelines/generalized-step-config-editor/StepConfigEditorTypes';
import {ShapeUISchemaV2} from 'pipelines/generalized-step-config-editor/StepConfigEditorTypes';
import {PipelineConfigJsonSpec} from 'pipelines/StepShapeUtils';
import {JSONValue, RenameAndReplaceKey} from 'util/Types';

import {AnalysisDataLayout} from './analysis-adapter/AnalysisAdapterTypes';

export interface ConfigFormField {
  key: string;
  config: JSONValue;
  configShape: PipelineConfigJsonSpec;
  configDataFrameInfo: ConfigDataFrameInfo | null;
}

export type DataLayout = Pick<
  RenameAndReplaceKey<
    RenameAndReplaceKey<
      RenameAndReplaceKey<AnalysisDataLayout, 'inputReference', 'view', AnalysisViewGraphQL>,
      'configFields',
      'configFields',
      Array<ConfigFormField>
    >,
    'uiSchema',
    'uiSchema',
    ShapeUISchemaV2
  >,
  'sections' | 'name'
>;
export type DataLayoutSection = DataLayout['sections'][number];
export type GridSection = Extract<DataLayoutSection, {type: 'GRID'}>;
export type GridMode = Exclude<GridSection['gridMode'], null>;
export type NestedGrid = Extract<Block, {type: 'NESTED_GRID'}>;
export type Block = GridSection['rows'][number][number];
export type ConfigFormBlock = Extract<Block, {type: 'CONFIG_FORM'}>;
export type DataViewBlock = Extract<Block, {type: 'DATA'}>;
export type MarkdownBlock = Extract<Block, {type: 'MARKDOWN'}>;
export type GridBlock = ConfigFormBlock | DataViewBlock | MarkdownBlock;
export type TabSection = Extract<DataLayoutSection, {type: 'TAB'}>;
export type Tab = TabSection['tabs'][number];
export type BlockConfig = GridBlock['blockConfig'];

export enum ConfigFormAction {
  RESET = 'RESET',
  SUBMIT = 'SUBMIT',
}
export interface ConfigFormFieldEvent {
  type: 'CONFIG_FORM_FIELD';
  layoutPath: Array<string | number>;
  newValue: JSONValue;
}

export type LayoutEvent = ConfigFormFieldEvent;
